import { render } from "./SideBarFooter.vue?vue&type=template&id=6ec6f957&scoped=true"
import script from "./SideBarFooter.vue?vue&type=script&lang=js"
export * from "./SideBarFooter.vue?vue&type=script&lang=js"

import "./SideBarFooter.vue?vue&type=style&index=0&id=6ec6f957&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec6f957"]])

export default __exports__